import React, { useState, useEffect } from "react";
import { ListGroup, ListGroupItem, Container, Row, Col, Button, Badge } from "react-bootstrap/";
import { LinkContainer } from "react-router-bootstrap";
import Moment from 'react-moment';
import { API } from "aws-amplify";

import { useAppContext } from "../libs/contextLib";
import { onError } from "../libs/errorLib";
import "./Home.css";
import { Link, useHistory, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle, faTheaterMasks, faMusic, faFilm } from '@fortawesome/free-solid-svg-icons'
import Loader from "components/Loader";


export default function Home() {
  const history = useHistory();
  const [shows, setShows] = useState([]);
  const [todayShows, setTodayShows] = useState([]);
  const {isAuthenticated, setIsAuthenticating, logout, getSession } = useAppContext();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingToday, setIsLoadingToday] = useState(true);
  const location = useLocation();

  useEffect(() => {
    async function onLoad() {
     /* if (!isAuthenticated) {
        return;
      }*/
      const session = getSession()
  
      try {        
        const todayShows = await loadShows(session, true);
        setTodayShows(todayShows)
      } catch (e) {
        onError(e);
      } finally {
        setIsLoadingToday(false);
      }

      try {
        const shows = await loadShows(session);
        setShows(shows)        
      } catch (e) {
        onError(e);
      } finally {
        setIsLoading(false);
      }
  

    }
  
    onLoad();
  }, [isAuthenticated]);
    

  function loadShows(session, today) {
    
    
    const dateFilter = today ? 'TODAY' : 'ALL'

    let producerFilter = session.producers
        ? "&producer=" + session.producers.map(p => p._id).join('|')
        : ""
    // let userFilter = "&user=" + session.session.user_uid
        
    let shows = API.get("vivelo", `/shows?filter=${dateFilter}&sort=-1&visible=-1&type=VENUE|MIXED${producerFilter}&limit=100`);
    return shows || { items: [] }    
  }

  async function handleLogout() {    
    setIsAuthenticating(true);

    try {
      await logout()
      history.push("/");
    } catch (e) {
      onError(e)      
    } finally {
      setIsAuthenticating(false);
    }
  }

  function renderGenreIcon(show) {
    switch(show.icon) {
      case 'theater':
        return <FontAwesomeIcon icon={faTheaterMasks} />
      break;

      case 'movie':
        return <FontAwesomeIcon icon={faFilm} />
      break;

      case 'music':
      default:
        return <FontAwesomeIcon icon={faMusic} />
      break;
    }
  }

  function renderShowStatus(show) {
    switch(show.status) {
      case 'LIVE':
        return <div className="live"><FontAwesomeIcon icon={faCircle} style={{color:"red"}} />&nbsp;&nbsp;EN VIVO</div>
      case 'ACTIVE':
      case 'TEST':
        return <div>ACTIVO</div>
      case 'CLOSED':
        return <div>CERRADO</div>
      case 'SOON':
        return <div>PRÓXIMAMENTE</div>
      default:
        return <div>{show.status}</div>
    }
  }

  function renderShowCards(shows) {
    let items = shows ? shows.items : []

    const cards = items
        .filter(s => s.settings && !s.settings.is_show_date)
        .map((show, i) => {
        return <Link key={`name-${show._id}`} to={`/shows/${show._id}`}>          
        <div className="show-card">
          <div>
            <div className="show-card-image"><img src={show.main_image} /></div>
            <div className="show-card-footer">
              <div className="show-card-genre">{renderGenreIcon(show)}</div>
              { renderShowStatus(show) }              
            </div>
          </div>          
          <div className="show-card-info">
            <div className="show-card-left">
              <div className="show-card-day"><Moment local format="DD">{new Date(show.show_date)}</Moment></div>
              <div className="show-card-month"><Moment local format="MMM">{new Date(show.show_date)}</Moment></div>
              <div className="show-card-hour"><Moment local format="LT">{new Date(show.show_date)}</Moment></div>
            </div>
            <div className="show-card-right">
              <div className="show-card-title">{show.fullname}</div>
              <div>{show.settings.has_show_dates && `Múltiples funciones`}</div>
              {/* <div>
                <div>Admisión Q50 | 45 boletos | Q1,450.00</div>
                <div>Admisión Q50 | 45 boletos | Q1,450.00</div>
                <div>Admisión Q50 | 45 boletos | Q1,450.00</div>
              </div> */}
            </div>
          </div>                    
                    
        </div>        
        </Link>
    })    

    return <div className="show-card-list">
        {cards}
    </div>
  }

  function renderShowInfo2(show) {      
    return <Row className="show" noGutters>
      <div className="background" style={{backgroundImage: `url(${show.main_image})`}}>
      <LinkContainer key={`name-${show._id}`} to={`/shows/${show._id}`}>
        <div className="layer">
          <div className={`show-title primary`}>
                  
                      <>{show.fullname}</>
          </div>
          <div className={`show-date primary`}>
                    <Moment local format="ddd, LL - LT">{new Date(show.show_date)}</Moment>
            </div>
            <div className={`show-actions`}>
                  { show.status == "SOON" && 
                    <Badge variant="info" >Pr&oacute;ximamente</Badge> 
                  }
                  { ['ACTIVE','STARTED','LIVE'].includes(show.status) && 
                    <Badge variant="success" style={{marginLeft: 'auto'}} >Activo</Badge>
                  }
                
            </div>
            {show.istatus == "LIVE" &&
              <div className="live-overlay"><div><FontAwesomeIcon icon={faCircle} style={{color:"red"}} />&nbsp;&nbsp;EN VIVO</div></div>
            }
        </div>
        </LinkContainer>
      </div>

    </Row>
  }

  function renderShowsList(shows) {    

    let items = shows ? shows.items : []

    // let primaryShow = null;
    // let secondaryShows = [];
    // items.map((show, i) => {
    //     if (i === 0) {
    //         primaryShow = renderShowInfo2(show)
    //     } else {
    //         secondaryShows.push(renderShowInfo2(show))
    //     }
    // })

    return <>       
        <div className="content">
              { renderShowCards(shows) }
        </div>
        {/* <Container className="home-menu">      
          <Row className="nav justify-content-center">                      
            <Link to={`/shows/past`}  className="nav-item">Shows Pasados</Link>            
          </Row>   
        </Container>  */}
        </>      
  }

  function renderShows() {
    return (
      <div className="shows">
        <br />
        {!isLoadingToday ? todayShows?.items.length ? <><h2>Hoy</h2>{renderShowsList(todayShows)}</> : <></> : <Loader /> }
        <h2>Eventos</h2>
        {!isLoading ? renderShowsList(shows) : <Loader />}        
      </div>
    );
  }

  return (
    <div className="Home">
      {renderShows()}      
    </div>
  );
}